import styled, {keyframes} from 'styled-components';

const starFly = keyframes`
    0% {
        transform: translateY(20px) scale(0.4) rotate(0deg);
        opacity: 0;
    }
    20% {
        transform: translateY(0) scale(1) rotate(60deg);
        opacity: 1;
    }
    70% {
        transform: translateY(-90px) scale(0.95) rotate(220deg);
        opacity: 1;
    }
    100% {
        transform: translateY(-160px) scale(0.3) rotate(360deg);
        opacity: 0;
    }
`;

export const illustrationRoot = styled.div`
    position: relative;
    width: 201px;
    height: 201px;
    flex-shrink: 0;
    overflow: visible;
`;

export const starsLayer = styled.div`
    position: absolute;
    z-index: 2;
    inset: 0;
    overflow: visible;
    pointer-events: none;
`;

export const flyingStarImg = styled.img`
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
    pointer-events: none;
    filter: drop-shadow(0 2px 8px rgba(255, 204, 0, 0.5));
`;

export const flyingStar = styled.span`
    position: absolute;
    top: 6px;
    opacity: 0;
    pointer-events: none;
    animation: ${starFly} 3.2s ease-out infinite;

    &:nth-child(1) {
        left: 28%;
        width: 24px;
        height: 24px;
        animation-delay: 0s;
    }

    &:nth-child(2) {
        right: 22%;
        width: 14px;
        height: 14px;
        animation-delay: 0.7s;
    }

    &:nth-child(3) {
        left: 10%;
        width: 28px;
        height: 28px;
        animation-delay: 1.4s;
    }

    &:nth-child(4) {
        right: 8%;
        width: 18px;
        height: 18px;
        animation-delay: 2.1s;
    }

    @media (prefers-reduced-motion: reduce) {
        animation: none !important;
        opacity: 0;
    }
`;

export const loaderVideo = styled.video`
    position: relative;
    z-index: 1;
    display: block;
    width: 200px;
    height: 200px;
    object-fit: contain;
    border-radius: 12px;
`;
